import script from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"

import "./EmptyLayout.vue?vue&type=style&index=0&id=59bfc264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bfc264"]])

export default __exports__